import { createAuthClient } from 'better-auth/react';

import { API_URL } from './config.js';

/**
 * Better Auth browser client.
 *
 * `credentials: 'include'` is essential: the session is an httpOnly cookie
 * issued by the API, which is a different origin from the client in every
 * environment.
 */
export const authClient = createAuthClient({
  baseURL: API_URL,
  basePath: '/api/auth',
  fetchOptions: { credentials: 'include' },
});
